import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Input, ModalBody, ModalFooter} from 'reactstrap';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import Modal from '../../../shared/ui/Modal';
import tagsSelectors from '../../store/tags/selectors';
import taskGroupsActions from '../../store/task-groups/action-creators/index';
import taskGroupsSelectors from '../../store/task-groups/selectors';
import TaskGroupTable from './TaskGroupTable';
import TaskGroupAdd from './TaskGroupAdd';
import TaskGroupTagsManage from './TaskGroupTagsManage';
import AttachTaskGroups from "../../../admin-app/components/config-task-groups/AttachTaskGroups";
import taskConfigActionCreators from "../../../admin-app/store/tasks-config/action-creators";
import LoadingButton from "../../../shared/ui/LoadingButton";
import ApiService from '../../../shared/services/api-service';
import notificationsActionsCreator from "../../store/notifications/action-creators";
import departmentSettingsSelectors from "../../store/department-settings/selectors";

class TaskGroupIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDeleteMessage: '',
      isManagingTags: false,
      deleteTaskGroupGuid: '',
      isOpenAttachTaskGroups: false,
      isAttachTaskToOitLoading: false,
      taskGroupForActivation: null,
      submitter: null,
      taskGroupStatus: 'current'
    };
    this.onCloneTaskGroup = this.onCloneTaskGroup.bind(this);
  }

  // ----------------------
  // Handlers
  // ----------------------

  get filteredTaskGroups() {
    return this.props.taskGroups
      ? this.props.taskGroups
        .filter(g => !g.parent_guid)
        .filter(g => {
          if(!this.state.submitter) {
            return true
          }
          return g.flow && this.state.submitter.includes(g.flow.acknowledger)
        })
        .filter(g => {

          if(this.state.taskGroupStatus) {
            return g.status === this.state.taskGroupStatus
          }

          return null
        })
      : this.props.taskGroups;
  }

  onShowTaskGroupDetails(taskGroupGuid) {
    this.props.setSelectedTaskGroup(taskGroupGuid);
    if (this.props.userContext.hasScope('admin')) {
      this.props.history.push(`/admin/task-groups/${taskGroupGuid}`);
    } else {
      this.props.history.push(`/task-groups/${taskGroupGuid}`);
    }
  }

  // ----------------------
  // Methods
  // ----------------------

  refreshTaskGroups() {
    if(this.props.userContext.hasScope('admin')) {
      this.props.fetchConfigTaskGroups();
    }
    this.props.loadTaskGroupContainer();
  }

  onCloneTaskGroup(taskGroupGuid) {
    const formData = {
      taskGroupGuid,
    };
    this.props.cloneTaskGroup(formData)
      .then(() => {
        this.refreshTaskGroups();
      })
  }

  deleteTaskGroup(deleteTaskGuid) {
    this.setState({
      confirmDeleteMessage: '',
      isDeletingTaskGroup: false,
      deleteTaskGroupGuid: null,
    });
    this.props.deleteTaskGroup(deleteTaskGuid);
  }

  attachTasks(taskGroups) {
    this.props.attachTasks(taskGroups)
      .then(res => {
        this.props.loadTaskGroupContainer();
        this.toggleAttachTaskGroups();
      });
  }

  confirmDeleteTaskGroup(taskGroupGuid) {
    const taskGroupToDelete = this.props.taskGroups.find((taskGroup) => {
      return taskGroup.taskGroupGuid === taskGroupGuid;
    });
    this.setState({
      confirmDeleteMessage: `Delete Task Group draft labelled "${
        taskGroupToDelete.name
        }"?`,
      isDeletingTaskGroup: true,
      deleteTaskGroupGuid: taskGroupGuid,
    });
  }

  // ----------------------
  // State Setters
  // ----------------------

  assignTasksToOits() {
    this.setState({
      isAttachTaskToOitLoading: true
    });
    ApiService.post(`/api/v1/admin/departments/${this.props.userContext.departmentGuid}/assign-tasks-for-oits`)
      .then(res => {
        if (res.status === 201) {
          this.props.addSavedSuccessfully('Task successfully added to oits')
        } else if (res.status === 200) {
          this.props.addSavedSuccessfully('No changes made to oits task training')
        }
        this.setState({
          isAttachTaskToOitLoading: false
        });
      })
      .catch(res => {
        this.props.addError('Error assigning tasks to oits')
        this.setState({
          isAttachTaskToOitLoading: false
        });
      })
  }

  closeManageTags() {
    this.setState({isManagingTags: false});
    this.props.setSelectedTaskGroup(null);
  }

  toggleAttachTaskGroups() {
    this.setState({
      isOpenAttachTaskGroups: !this.state.isOpenAttachTaskGroups
    })
  }

  openManageTags(userGuid) {
    this.setState({isManagingTags: true});
    this.props.setSelectedTaskGroup(userGuid);
  }

  closeActivateTaskGroupModal() {
    this.setState({
      taskGroupForActivation: null
    })
  }

  setForActivation(taskGroupGuid) {
    this.setState({
      taskGroupForActivation: taskGroupGuid
    })
  }

  activateAndAttach() {
    this.props.activateTaskGroup(this.state.taskGroupForActivation, true)
    this.closeActivateTaskGroupModal()
  }

  activate() {
    this.props.activateTaskGroup(this.state.taskGroupForActivation)
    this.closeActivateTaskGroupModal()
  }

  setTaskGroupStatus(value) {
    this.setState({
      taskGroupStatus: value
    })
  }

  filterTaskGroups(submitter) {
    let submitterRoles = '';
    if (submitter == 'submitted-by-me') {
      submitterRoles = this.props.userContext.roles.map(r => r.scope == 'ftoc' ? 'fto' : r.scope);
    }

    this.setState({
      submitter: submitterRoles
    });

    this.filteredTaskGroups;
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        <div className="app-content-header">
          <div>

            <h4 className="title">Task Groups</h4>
          </div>
          <div>
            {this.props.userContext.hasScope('admin') && (
              <Fragment>
                <LoadingButton
                  primary
                  small
                  isLoading={this.state.isAttachTaskToOitLoading}
                  onClick={() => this.assignTasksToOits()}
                  icon="fa fa-user-secret"
                  text={`Assign tasks groups to ${this.props.oitShortLabel}S`}/>

                <button className="button secondary small" style={{marginLeft: "20px", marginRight: "20px"}}
                        onClick={() => this.toggleAttachTaskGroups()}>
                  <i className="fa fa-plus"/>
                  <span>Attach default task groups to this department</span>
                </button>
              </Fragment>
            )}
            <button className="button primary small" onClick={() => this.props.addTaskGroup()}>
              <i className="fa fa-plus"/>
              <span>Add Task group</span>
            </button>
          </div>
        </div>
        <div className="app-content">
          {this.props.taskGroups && (
            <div>
              <div className="form form-inline">
                <div className="form-group" style={{flex: 0.3}}>
                  <Input
                    name="type"
                    onChange={event =>
                      this.filterTaskGroups(event.target.value)
                    }
                    type="select"
                  >
                    <option value="">Show All</option>
                    <option value="submitted-by-me">Submitted by me</option>
                  </Input>
                </div>

                <div className="form-group ml-2" style={{flex: 0.3}}>
                  <Input
                    name="type"
                    onChange={event =>
                      this.setTaskGroupStatus(event.target.value)
                    }
                    value={this.state.taskGroupStatus}
                    type="select"
                  >
                    <option value="current">Current</option>
                    <option value="draft">Draft</option>
                    <option value="archived">Archived</option>
                  </Input>
                </div>
              </div>

              <TaskGroupTable
                onActivateTaskGroup={taskGroupGuid =>
                  this.setForActivation(taskGroupGuid)
                }
                onArchiveTaskGroup={taskGroupGuid =>
                  this.props.archiveTaskGroup(taskGroupGuid)
                }
                onCloneTaskGroup={this.onCloneTaskGroup}
                onDeleteTaskGroup={taskGroupGuid =>
                  this.confirmDeleteTaskGroup(taskGroupGuid)
                }
                onManageTags={taskGroupGuid => this.openManageTags(taskGroupGuid)}
                onShowDetails={taskGroupGuid =>
                  this.onShowTaskGroupDetails(taskGroupGuid)
                }
                taskGroups={this.filteredTaskGroups}
              />
            </div>
          )}
        </div>
        <Modal
          isOpen={this.props.isAddingTaskGroup}
          title="Create Task Group"
          onClose={() => this.props.closeAddTaskGroup()}
        >
          <TaskGroupAdd/>
        </Modal>
        <Modal
          isOpen={this.state.isManagingTags}
          title={`Manage tags for ${this.selectedUserFullName}`}
          onClose={() => this.closeManageTags()}
        >
          <TaskGroupTagsManage
            tags={this.props.taskGroupTags}
            taskGroup={this.props.selectedTaskGroup}
          />
        </Modal>
        <Modal
          isOpen={this.state.isDeletingTaskGroup}
          onClose={() => this.setState({isDeletingTaskGroup: false})}
          title="Confirm Delete Task Group Draft"
        >
          <ModalBody>{this.state.confirmDeleteMessage}</ModalBody>
          <ModalFooter>
            <button
              className="button primary"
              onClick={() => this.deleteTaskGroup(this.state.deleteTaskGroupGuid)}
            >
              Remove
            </button>
            <button
              className="button"
              onClick={() => this.setState({isDeletingTaskGroup: false})}
            >
              Cancel
            </button>
          </ModalFooter>
        </Modal>
        {this.props.configTaskGroups && (
          <Modal
            isOpen={this.state.isOpenAttachTaskGroups}
            title="Attach default task groups to this department"
            onClose={() => this.toggleAttachTaskGroups()}
          >
            <AttachTaskGroups
              configTaskGroups={this.props.configTaskGroups}
              isLoading={this.props.isLoadingTaskConfig.includes('attachTasks')}
              onAttachTasks={(taskGroups) => this.attachTasks(taskGroups)}
            />
          </Modal>
        )}

        <Modal
          isOpen={this.state.taskGroupForActivation}
          title="Activate task group"
          onClose={() => this.closeActivateTaskGroupModal()}
        >
          <div className="task-group-activate-modal">
            <h4>Do you want to attach this task group to officers already in training?</h4>
            <div>
              <button className="button secondary" onClick={() => this.activate()}>
                No
              </button>
              <button className="button primary" onClick={() => this.activateAndAttach()}>
                Yes
              </button>
            </div>
          </div>
        </Modal>

      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isAddingTaskGroup: state.taskGroups.isAddingTaskGroup,
    isLoading: state.taskGroups.isLoading.length > 0,
    isLoadingTaskConfig: state.taskConfig && state.taskConfig.isLoading,
    selectedTaskGroup: taskGroupsSelectors.selectedTaskGroup(state),
    taskGroups: state.taskGroups.list,
    taskGroupTags: tagsSelectors.taskGroupTags(state),
    userContext: state.common.userContext,
    configTaskGroups: state.taskConfig && state.taskConfig.taskGroups,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    activateTaskGroup: (taskGroupGuid, attach) => {
      dispatch(taskGroupsActions.activateTaskGroup(taskGroupGuid, attach));
    },
    addTaskGroup: () => {
      dispatch(taskGroupsActions.addTaskGroup());
    },
    archiveTaskGroup: (taskGroupGuid) => {
      dispatch(taskGroupsActions.archiveTaskGroup(taskGroupGuid));
    },
    cloneTaskGroup: (formData) => {
      return dispatch(taskGroupsActions.cloneTaskGroup(formData));
    },
    deleteTaskGroup: (deleteTaskGuid) => {
      dispatch(taskGroupsActions.deleteTaskGroup(deleteTaskGuid));
    },
    closeAddTaskGroup: () => {
      dispatch(taskGroupsActions.closeAddTaskGroup());
    },
    setSelectedTaskGroup: (taskGroupGuid) => {
      return dispatch(taskGroupsActions.setSelectedTaskGroup(taskGroupGuid));
    },
    loadTaskGroupContainer: () => {
      return dispatch(taskGroupsActions.loadTaskGroupContainer());
    },
    attachTasks: (taskGroups) =>
      dispatch(taskConfigActionCreators.attachTasks(taskGroups)),
    addSavedSuccessfully: message =>
      dispatch(notificationsActionsCreator.addSavedSuccessfully(message)),
    addError: message =>
      dispatch(notificationsActionsCreator.addError(message)),
    fetchConfigTaskGroups: () =>
      dispatch(taskConfigActionCreators.fetchConfigTaskGroups()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskGroupIndex);
